// assets/scripts/js/blocks/video-swiper.js

import Swiper from 'swiper/bundle';
// DO NOT import any CSS here
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';

document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('.video-swiper');
  if (!containers.length) return;

  const PAUSE_MSG = '{"method":"pause"}';
  const PLAY_MSG  = '{"method":"play"}';

  const pauseVideos = (root) => {
    root.querySelectorAll('.swiper-slide iframe').forEach((iframe) => {
      try { iframe.contentWindow.postMessage(PAUSE_MSG, '*'); } catch {}
    });
  };

  const resetToggles = (root) => {
    root.querySelectorAll('.toggle-video').forEach((btn) => {
      btn.classList.remove('active');
      const sr = btn.querySelector('.screen-reader-text');
      if (sr) sr.textContent = 'Play';
      btn.setAttribute('aria-pressed', 'false');
    });
  };

  containers.forEach((container, index) => {
    const next = container.querySelector('.swiper-button-next');
    const prev = container.querySelector('.swiper-button-prev');
    const pagination = container.querySelector('.swiper-pagination');

    const swiper = new Swiper(container, {
      loop: true,
      autoHeight: true,
      speed: 600,
      spaceBetween: 16,
      watchOverflow: true,
      navigation: next && prev ? { nextEl: next, prevEl: prev } : undefined,
      pagination: pagination ? { el: pagination, clickable: true } : undefined,
      keyboard: { enabled: true },
      a11y: {
        enabled: true,
        containerMessage: 'Video carousel',
        slideLabelMessage: 'Slide {{index}} of {{slidesLength}}',
      },
      on: {
        slideChangeTransitionStart() {
          pauseVideos(container);
          resetToggles(container);
        },
      },
    });

    if (next) next.addEventListener('click', () => { pauseVideos(container); resetToggles(container); });
    if (prev) prev.addEventListener('click', () => { pauseVideos(container); resetToggles(container); });

    // Play/Pause toggle for Vimeo
    container.addEventListener('click', (e) => {
      const btn = e.target.closest('.toggle-video');
      if (!btn) return;

      const id = btn.getAttribute('data-id');
      const frame = container.querySelector(`#video-${id} iframe`);
      if (!frame) return;

      const sr = btn.querySelector('.screen-reader-text');
      const isPlay = sr && sr.textContent.trim().toLowerCase() === 'play';

      try { frame.contentWindow.postMessage(isPlay ? PLAY_MSG : PAUSE_MSG, '*'); } catch {}

      if (isPlay) {
        btn.classList.add('active');
        if (sr) sr.textContent = 'Pause';
        btn.setAttribute('aria-pressed', 'true');
      } else {
        btn.classList.remove('active');
        if (sr) sr.textContent = 'Play';
        btn.setAttribute('aria-pressed', 'false');
      }
    });
  });
});